module.exports = __webpack_public_path__ + "static/media/oven-on.91caeea0.png";